export default __webpack_public_path__ + "images/0151300f25ed795e59659702b23c8135-dance.jpg";